import { Battery, Car, Layers, Cpu, Building2 } from 'lucide-react'

export function getPoolIcon(
    pool: { controlConfig?: { purpose?: string }; forecastConfigs?: Array<{ purpose?: string }> } | any,
) {
  const purpose = pool?.controlConfig?.purpose
  if (purpose === 'intraday' || purpose === 'intraday_cloud') return Car
  if (purpose === 'tou_stacking_poc') return Layers
  if (purpose === 'imbalance') return Battery

  const forecasts: Array<{ purpose?: string }> = pool?.forecastConfigs ?? []
  if (forecasts.some((f) => f.purpose === 'ev')) return Car
  if (forecasts.some((f) => f.purpose?.startsWith('gcp'))) return Battery

  return Battery
}
export type ForecastPurpose = 'gcp_supply' | 'gcp_feed_in' | 'gcp_without_ev' | 'ev'

export const FORECAST_PURPOSES: Array<{
  value: ForecastPurpose
  label: string
  description: string
}> = [
  {
    value: 'gcp_supply',
    label: 'GCP Supply Forecasting',
    description: 'Day-ahead grid connection point supply (import) forecast',
  },
  {
    value: 'gcp_feed_in',
    label: 'GCP Feed-in Forecasting',
    description: 'Day-ahead grid connection point feed-in (export) forecast',
  },
  {
    value: 'gcp_without_ev',
    label: 'GCP without EV Forecasting',
    description: 'Grid connection point forecast excluding EV charging load',
  },
  {
    value: 'ev',
    label: 'EV Forecasting',
    description: 'EV charging demand forecast via Enode',
  },
]

export function forecastPurposeLabel(purpose: string): string {
  return FORECAST_PURPOSES.find((p) => p.value === purpose)?.label ?? purpose
}

export { Layers as PoolIcon }
export { Cpu as SystemIcon }
export { Building2 as AccountIcon }
